import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import {baseUrl, ipAddress, userName} from "../Univ";

function PurchaseReturn() {

    const [loading, setLoading] = useState(false);

    const [rows, setRows] = useState([]);

    const [purchaseOrders, setPurchaseOrders] = useState([]);

    const [editId, setEditId] = useState(null);

    const [formData, setFormData] = useState({

        return_no: "",

        purchase_order: "",

        supplier: "",

        return_date: "",

        reason: "",

        total_amount: "",

        status: "DRAFT"

    });

    const [returnItems, setReturnItems] = useState([
        {
            purchase_order_item: "",
            item_name: "",
            ordered_qty: "",
            returned_qty: "",
            available_qty: "",
            return_qty: "",
            rate: "",
            total: "",
            remarks: ""
        }
    ]);

    useEffect(() => {

        getPurchaseReturns();

        getPurchaseOrders();

    }, []);

    const getPurchaseReturns = () => {

        setLoading(true);

        axios.get(baseUrl + "purchase-return/")
            .then((res) => {

                setRows(res.data);

                setLoading(false);

            })
            .catch(() => {

                setLoading(false);

            });

    };

    const getPurchaseOrders = () => {

        axios.get(baseUrl + "purchase-order/")
            .then((res) => {

                setPurchaseOrders(res.data);

            });

    };

    const handleChange = (e) => {

        setFormData({

            ...formData,

            [e.target.name]: e.target.value

        });

    };

    // ==========================================
    // LOAD PURCHASE ORDER ITEMS
    // ==========================================

    const loadPurchaseOrderItems = async (purchaseOrderId) => {

        if (!purchaseOrderId) {

            setReturnItems([]);

            return;

        }

        try {

            const res = await axios.get(
                baseUrl + `purchase-order-item/${purchaseOrderId}/`
            );

            setReturnItems(

                res.data.map((row) => ({

                    purchase_order_item: row.id,

                    item_name: row.item.item_name,

                    ordered_qty: Number(row.quantity),

                    returned_qty: Number(row.returned_qty || 0),

                    available_qty:
                        Number(row.quantity) -
                        Number(row.returned_qty || 0),

                    return_qty: 0,

                    rate: Number(row.rate),

                    total: 0,

                    remarks: ""

                }))

            );

            const po = purchaseOrders.find(
                (x) => x.id === parseInt(purchaseOrderId)
            );

            if (po) {

                setFormData((prev) => ({

                    ...prev,

                    supplier: po.supplier.id

                }));

            }

        } catch (err) {

            console.log(err);

        }

    };

    // ==========================================
    // PURCHASE ORDER CHANGED
    // ==========================================

    const handlePurchaseOrder = async (e) => {

        const value = e.target.value;

        setFormData({

            ...formData,

            purchase_order: value

        });

        await loadPurchaseOrderItems(value);

    };
        // ==========================================
    // RETURN ITEM CHANGED
    // ==========================================

    const handleReturnItemChange = (index, e) => {

        const {name, value} = e.target;

        const data = [...returnItems];

        data[index][name] = value;

        if (name === "return_qty") {

            const qty = parseFloat(value || 0);

            const available = parseFloat(
                data[index].available_qty || 0
            );

            if (qty > available) {

                Swal.fire(
                    "Warning",
                    `Maximum Return Qty : ${available}`,
                    "warning"
                );

                data[index].return_qty = available;

            }

            const rate = parseFloat(
                data[index].rate || 0
            );

            data[index].total =
                (
                    parseFloat(data[index].return_qty || 0)
                    * rate
                ).toFixed(2);

        }

        if (name === "rate") {

            const qty = parseFloat(
                data[index].return_qty || 0
            );

            data[index].total =
                (
                    qty *
                    parseFloat(value || 0)
                ).toFixed(2);

        }

        setReturnItems(data);

        calculateGrandTotal(data);

    };


    // ==========================================
    // GRAND TOTAL
    // ==========================================

    const calculateGrandTotal = (rows) => {

        let total = 0;

        rows.forEach((row) => {

            total += parseFloat(row.total || 0);

        });

        setFormData((prev) => ({

            ...prev,

            total_amount: total.toFixed(2)

        }));

    };


    // ==========================================
    // ADD ROW
    // ==========================================

    const addRow = () => {

        setReturnItems([

            ...returnItems,

            {

                purchase_order_item: "",

                item_name: "",

                ordered_qty: "",

                returned_qty: "",

                available_qty: "",

                return_qty: "",

                rate: "",

                total: "",

                remarks: ""

            }

        ]);

    };


    // ==========================================
    // REMOVE ROW
    // ==========================================

    const removeRow = (index) => {

        const data = [...returnItems];

        data.splice(index, 1);

        setReturnItems(data);

        calculateGrandTotal(data);

    };


    // ==========================================
    // CLEAR FORM
    // ==========================================

    const clearForm = () => {

        setEditId(null);

        setFormData({

            return_no: "",

            purchase_order: "",

            supplier: "",

            return_date: "",

            reason: "",

            total_amount: "",

            status: "DRAFT"

        });

        setReturnItems([
            {

                purchase_order_item: "",

                item_name: "",

                ordered_qty: "",

                returned_qty: "",

                available_qty: "",

                return_qty: "",

                rate: "",

                total: "",

                remarks: ""

            }
        ]);

    };
        // ==========================================
    // SAVE
    // ==========================================

    const saveData = async (e) => {

        e.preventDefault();

        setLoading(true);

        try {

            const header = new FormData();

            header.append("return_no", formData.return_no);

            header.append("purchase_order_id", formData.purchase_order);

            header.append("supplier_id", formData.supplier);

            header.append("return_date", formData.return_date);

            header.append("reason", formData.reason);

            header.append("total_amount", formData.total_amount);

            header.append("status", "PENDING");

            header.append("addedby", userName);

            header.append("ip_add", ipAddress);

            let returnId = editId;

            if (editId === null) {

                const res = await axios.post(
                    baseUrl + "purchase-return/",
                    header
                );

                returnId = res.data.id;

            } else {

                await axios.put(
                    baseUrl + `update-purchase-return/${editId}/`,
                    header
                );

            }

            for (const row of returnItems) {

                if (parseFloat(row.return_qty || 0) <= 0)
                    continue;

                const item = new FormData();

                item.append(
                    "purchase_return",
                    returnId
                );

                item.append(
                    "purchase_order_item_id",
                    row.purchase_order_item
                );

                item.append(
                    "return_qty",
                    row.return_qty
                );

                item.append(
                    "rate",
                    row.rate
                );

                item.append(
                    "total",
                    row.total
                );

                item.append(
                    "remarks",
                    row.remarks
                );

                if (row.id) {

                    await axios.put(
                        baseUrl +
                        `update-purchase-return-item/${row.id}/`,
                        item
                    );

                } else {

                    await axios.post(
                        baseUrl +
                        "purchase-return-item/",
                        item
                    );

                }

            }

            Swal.fire(
                "Success",
                editId === null
                    ? "Purchase Return Submitted For Approval"
                    : "Purchase Return Updated",
                "success"
            );

            clearForm();

            getPurchaseReturns();

        } catch (err) {

            console.log(err);

            Swal.fire(
                "Error",
                "Unable to Save Purchase Return",
                "error"
            );

        }

        setLoading(false);

    };


    // ==========================================
    // EDIT
    // ==========================================

    const editData = async (row) => {

        setEditId(row.id);

        setFormData({

            return_no: row.return_no,

            purchase_order: row.purchase_order.id,

            supplier: row.supplier.id,

            return_date: row.return_date,

            reason: row.reason,

            total_amount: row.total_amount,

            status: row.status

        });

        await loadPurchaseOrderItems(
            row.purchase_order.id
        );

        const res = await axios.get(
            baseUrl +
            `purchase-return-item/${row.id}/`
        );

        setReturnItems(

            res.data.map((item) => ({

                id: item.id,

                purchase_order_item:
                    item.purchase_order_item.id,

                item_name:
                    item.purchase_order_item.item.item_name,

                ordered_qty:
                    item.purchase_order_item.quantity,

                returned_qty:
                    item.purchase_order_item.returned_qty,

                available_qty:
                    item.purchase_order_item.quantity -
                    item.purchase_order_item.returned_qty,

                return_qty:
                    item.return_qty,

                rate:
                    item.rate,

                total:
                    item.total,

                remarks:
                    item.remarks

            }))

        );

    };


    // ==========================================
    // DELETE
    // ==========================================

    const deleteData = (id) => {

        Swal.fire({

            title: "Delete Purchase Return?",

            icon: "warning",

            showCancelButton: true

        }).then((result) => {

            if (result.isConfirmed) {

                axios.delete(
                    baseUrl +
                    `update-purchase-return/${id}/`
                ).then(() => {

                    Swal.fire(
                        "Deleted",
                        "",
                        "success"
                    );

                    getPurchaseReturns();

                });

            }

        });

    };


    // ==========================================
    // GRID
    // ==========================================

    const columns = [

        {
            field: "return_no",
            headerName: "Return No",
            width: 150
        },

        {
            field: "purchase_order",
            headerName: "PO No",
            width: 150,
            renderCell: (params) =>
                params.row.purchase_order?.po_no
        },

        {
            field: "supplier",
            headerName: "Supplier",
            width: 220,
            renderCell: (params) =>
                params.row.supplier?.name
        },

        {
            field: "return_date",
            headerName: "Return Date",
            width: 140
        },

        {
            field: "status",
            headerName: "Workflow",
            width: 130
        },

        {
            field: "total_amount",
            headerName: "Amount",
            width: 140
        },

        {
            field: "action",
            headerName: "Action",
            width: 240,
            sortable: false,
            renderCell: (params) => (

                <>

                    <button
                        className="btn btn-success btn-sm me-2"
                        onClick={() => editData(params.row)}
                    >
                        Edit
                    </button>

                    <button
                        className="btn btn-danger btn-sm"
                        onClick={() => deleteData(params.row.id)}
                    >
                        Delete
                    </button>

                </>

            )

        }

    ];
        return (

        <div className="container-fluid mt-3">

            <div className="card shadow">

                <div className="card-header bg-success text-white">

                    <h5 className="mb-0">

                        Purchase Return

                    </h5>

                </div>

                <div className="card-body">

                    <form onSubmit={saveData}>

                        <div className="row">

                            <div className="col-md-3 mb-3">

                                <label>Return No</label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="return_no"
                                    value={formData.return_no}
                                    onChange={handleChange}
                                    required
                                />

                            </div>

                            <div className="col-md-3 mb-3">

                                <label>Purchase Order</label>

                                <select
                                    className="form-control"
                                    name="purchase_order"
                                    value={formData.purchase_order}
                                    onChange={handlePurchaseOrder}
                                    required
                                >

                                    <option value="">
                                        Select Purchase Order
                                    </option>

                                    {purchaseOrders.map((po) => (

                                        <option
                                            key={po.id}
                                            value={po.id}
                                        >

                                            {po.po_no}

                                        </option>

                                    ))}

                                </select>

                            </div>

                            <div className="col-md-3 mb-3">

                                <label>Supplier</label>

                                <input
                                    type="text"
                                    className="form-control"
                                    value={
                                        purchaseOrders.find(
                                            x => x.id === Number(formData.purchase_order)
                                        )?.supplier?.name || ""
                                    }
                                    readOnly
                                />

                            </div>

                            <div className="col-md-3 mb-3">

                                <label>Status</label>

                                <input
                                    type="text"
                                    className="form-control"
                                    value={formData.status}
                                    readOnly
                                />

                            </div>

                            <div className="col-md-3 mb-3">

                                <label>Return Date</label>

                                <input
                                    type="date"
                                    className="form-control"
                                    name="return_date"
                                    value={formData.return_date}
                                    onChange={handleChange}
                                    required
                                />

                            </div>

                            <div className="col-md-6 mb-3">

                                <label>Reason</label>

                                <textarea
                                    rows="2"
                                    className="form-control"
                                    name="reason"
                                    value={formData.reason}
                                    onChange={handleChange}
                                    required
                                />

                            </div>

                            <div className="col-md-3 mb-3">

                                <label>Total Amount</label>

                                <input
                                    type="number"
                                    className="form-control"
                                    name="total_amount"
                                    value={formData.total_amount}
                                    readOnly
                                />

                            </div>

                        </div>

                        <hr/>

                        <h5 className="mb-3">

                            Purchase Return Items

                        </h5>
                                    <div className="table-responsive">

                            <table className="table-erp-modern">

                                <thead className="table-primary">

                                <tr>

                                    <th width="22%">
                                        Item
                                    </th>

                                    <th width="8%">
                                        Ordered
                                    </th>

                                    <th width="8%">
                                        Returned
                                    </th>

                                    <th width="8%">
                                        Available
                                    </th>

                                    <th width="8%">
                                        Return Qty
                                    </th>

                                    <th width="10%">
                                        Rate
                                    </th>

                                    <th width="10%">
                                        Total
                                    </th>

                                    <th width="18%">
                                        Remarks
                                    </th>

                                    <th width="8%">
                                        Action
                                    </th>

                                </tr>

                                </thead>

                                <tbody>

                                {returnItems.map((row, index) => (

                                    <tr key={index}>

                                        <td>

                                            <input
                                                type="text"
                                                className="form-control"
                                                value={row.item_name}
                                                readOnly
                                            />

                                        </td>

                                        <td>

                                            <input
                                                type="number"
                                                className="form-control"
                                                value={row.ordered_qty}
                                                readOnly
                                            />

                                        </td>

                                        <td>

                                            <input
                                                type="number"
                                                className="form-control"
                                                value={row.returned_qty}
                                                readOnly
                                            />

                                        </td>

                                        <td>

                                            <input
                                                type="number"
                                                className="form-control"
                                                value={row.available_qty}
                                                readOnly
                                            />

                                        </td>

                                        <td>

                                            <input
                                                type="number"
                                                step="0.01"
                                                className="form-control"
                                                name="return_qty"
                                                value={row.return_qty}
                                                onChange={(e)=>
                                                    handleReturnItemChange(index,e)
                                                }
                                            />

                                        </td>

                                        <td>

                                            <input
                                                type="number"
                                                step="0.01"
                                                className="form-control"
                                                name="rate"
                                                value={row.rate}
                                                onChange={(e)=>
                                                    handleReturnItemChange(index,e)
                                                }
                                            />

                                        </td>

                                        <td>

                                            <input
                                                type="number"
                                                className="form-control"
                                                value={row.total}
                                                readOnly
                                            />

                                        </td>

                                        <td>

                                            <input
                                                type="text"
                                                className="form-control"
                                                name="remarks"
                                                value={row.remarks}
                                                onChange={(e)=>
                                                    handleReturnItemChange(index,e)
                                                }
                                            />

                                        </td>

                                        <td>

                                            {returnItems.length > 1 && (

                                                <button
                                                    type="button"
                                                    className="btn btn-danger btn-sm"
                                                    onClick={()=>
                                                        removeRow(index)
                                                    }
                                                >

                                                    Remove

                                                </button>

                                            )}

                                        </td>

                                    </tr>

                                ))}

                                </tbody>

                            </table>

                        </div>

                        <div className="mt-2">

                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={addRow}
                            >

                                + Add Row

                            </button>

                        </div>

                        <div className="mt-4">

                            <button
                                type="submit"
                                className="btn btn-success me-2"
                                disabled={loading}
                            >

                                {editId === null
                                    ? "Submit Purchase Return"
                                    : "Update Purchase Return"}

                            </button>

                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={clearForm}
                            >

                                Clear

                            </button>

                        </div>

                    </form>

                </div>

            </div>


            <div className="card shadow mt-3">

                <div className="card-header bg-primary text-white">

                    <h5 className="mb-0">

                        Purchase Return List

                    </h5>

                </div>

                <div className="card-body">

                    <div
                        style={{
                            height:600,
                            width:"100%"
                        }}
                    >

                        <ERPDataGrid

                            rows={rows}

                            columns={columns}

                            loading={loading}

                            getRowId={(row)=>row.id}

                            pageSizeOptions={[10,25,50,100]}

                            initialState={{
                                pagination:{
                                    paginationModel:{
                                        pageSize:10
                                    }
                                }
                            }}

                            disableRowSelectionOnClick

                        />

                    </div>

                </div>

            </div>

        </div>

    );

}

export default PurchaseReturn;